import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button as AntButton } from 'antd';
import 'antd/dist/antd.css';

import { managementRoutes, stakeholderManagementRoutes, stakeholderOperationRoutes } from '../../../navigation';
import { useCurrentPortal } from '../../../hooks';
import { getLangFromStorage } from '../../../utils';
import { Button, Breadcrumbs, LanguageSwitcher, Tooltip } from '..';

import style from './Header.module.scss';


export const Header = ({ fullName = 'fullName', language, onUsernameClick, onLogout, status, portal }) => {
  const [ t ] = useTranslation();
  const currentLanguage = {
    'ar': 'ar-SA',
    'en': 'en-US'
  }[getLangFromStorage() || 'en'];


  const currentPortal = `/${useCurrentPortal()}`;
  const manualPath = {
    [managementRoutes.MANAGEMENT]: `${process.env.PUBLIC_URL}/user-manual/MP-manual/index_${currentLanguage}.html`,
    [stakeholderManagementRoutes.STAKEHOLDER_MANAGEMENT]:
    `${process.env.PUBLIC_URL}/user-manual/SMP-manual/index_${currentLanguage}.html`,
    [stakeholderOperationRoutes.STAKEHOLDER_OPERATION]:
    `${process.env.PUBLIC_URL}/user-manual/SOP-manual/index_${currentLanguage}.html`
  }[currentPortal || managementRoutes.MANAGEMENT];

  return (
    <div className={ style.wrapper }>
      <div className={ style.breadcrumbs }>
        <Breadcrumbs language={ language } />
      </div>
      <div className={ style.toolbar }>
        <div>
          <Tooltip placement="bottomRight" title={ t('btns.userManual') }>
            <a rel="noopener noreferrer" target="_blank" href={ manualPath }>
              <AntButton ghost shape="circle" icon="question" />
            </a>
          </Tooltip>
        </div>
        <div>
          <LanguageSwitcher ghost={ true } />
        </div>
        <div>
          <div className={ style.profile }>
            <Button additions={ [ 'text-only' ] } onClick={ onUsernameClick }>
              <p className={ style.username }>{fullName}</p>
            </Button>
            {portal === 'sop' && (
              <div className={ style.status } additions={ [ 'text-only' ] }>
                <p className={ style.username }>
                  {`/ ${status}`}
                </p>
              </div>
              )}
          </div>
        </div>
        <div>
          <Tooltip placement="bottomRight" title={ t('btns.logout') }>
            <AntButton
              ghost
              shape="circle"
              icon="logout"
              onClick={ () => { onLogout(true, true); } }
            />
          </Tooltip>
        </div>
      </div>
    </div>
  );
};
